// src/store/slices/applicationRequestsThunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAY } from "../../../../Utils/academivYear";
import { putData, getData } from "../../../../services/apiEndpoints";
import { handleError } from "../../Common/Alerts/errorhandling.action";
import { setShowError } from "../../Common/Alerts/alertsSlice";


export const fetchApplicationRequests = createAsyncThunk(
    "applicationRequests/fetchApplicationRequests",
    async (data, { rejectWithValue, dispatch, getState }) => {
        try {
            const say = getAY();
            dispatch(setShowError(false));
            const response = await getData(
                `/application/get-applications?say=${say}`, data
            );
            return response || [];
        } catch (error) {
            return handleError(error, dispatch, rejectWithValue);
        }
    }
);

export const updateApplicationRequest = createAsyncThunk(
    "applicationRequests/updateApplicationRequests",
    async (data, { rejectWithValue }) => {
        try {
            const response = await putData(
                `application/update-application?applicationId=${data?.applicationId}`,
                data
            );

            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || { message: "Server error" });
        }
    }
);

